import React, { FC, ReactNode, useCallback } from "react";
import _ from "lodash";
import mapUtils from "../../../utils/map";
import ListItemIcon from "./ListItemIcon";
import ListItemStyle from "./ListItemStyle";
import { ListFeature } from "../InventoryMapListPage";

const ListTable: FC<{
  features: (ListFeature & { distance: number })[];
  selectedFeatures: Record<string, ol.Feature>;
  onSelect: (feature: any) => void;
  sortSource: "GPS" | "MAP";
  iconAll: ReactNode;
}> = ({ features, selectedFeatures, onSelect, sortSource, iconAll }) => {
  const hasImage = useCallback((formdata: any) => {
    return _.find(formdata, (data) => {
      if (!data) {
        return false;
      }
      return _.find(data.values, (value) => {
        return value.type === "image" && value.value && value.value.length > 0;
      });
    });
  }, []);

  return (
    <table className="table  table-bordered">
      <thead>
        <tr>
          <th style={{ textAlign: "center" }}>{iconAll}</th>
          <th></th>
          <th>Title</th>
          <th style={{ textAlign: "center", fontSize: 15 }}>
            {sortSource === "GPS" ? <i className="fa fa-location-arrow"></i> : <i className="fa fa-expand"></i>}
          </th>
        </tr>
      </thead>
      <tbody>
        {features.map((feature) => (
          <tr key={feature.id} onClick={() => onSelect(feature)}>
            <td style={{ textAlign: "center" }}>
              <ListItemIcon selected={!!selectedFeatures[feature.id]} />
            </td>
            <td style={{ textAlign: "center" }}>
              <ListItemStyle
                featureType={feature.olFeature.getGeometry().getType()}
                color={mapUtils.getComputedStyle(mapUtils.inventoryStyle, [feature.olFeature])}
              />
            </td>
            <td style={{ minWidth: 100 }}>
              <span>{feature.title}</span>
              {hasImage(feature.formdata) ? (
                <i
                  className="fa fa-image"
                  style={{
                    float: "right",
                    position: "relative",
                    left: 6,
                    top: -8,
                  }}
                />
              ) : null}
            </td>
            <td>{Math.round(feature.distance)}m</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ListTable;
